import type {EagColumnGroup, EagColumnOrGroup} from '../types/EagColumnGroup';

export const isEagColumnGroup = (col: EagColumnOrGroup): col is EagColumnGroup => 'children' in col;
